// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bjeJ","toggle":"styles_toggle__3IUpV","preview":"styles_preview__1YJ2T"};